import { useVehicleContext } from '~/contexts/VehicleContext';
import usePriceDrop from '~/hooks/usePriceDrop';
import OriginalPrice from './OriginalPrice';
import Price from './Price';
import { useDiscount } from '../hooks';

export default function Pricing() {
  const { discountedPrice, totalDiscount, hasDiscount } = useDiscount();
  const { getPriceDrop, restrictedState } = usePriceDrop();
  const { vehicle } = useVehicleContext();
  const { showPriceDrop } = getPriceDrop(vehicle);

  return (
    <div className="flex flex-col h-full justify-end" data-qa="pricing">
      <div className="flex gap-4 t-body-s text-grey-5">
        {showPriceDrop && !restrictedState ? 'was' : ''}
        <OriginalPrice
          discountedPrice={discountedPrice}
          showDiscount={hasDiscount}
          showPriceDrop={showPriceDrop && !restrictedState}
          totalDiscount={totalDiscount}
        />
      </div>
      <Price
        discountedPrice={discountedPrice}
        showNewPriceIcon={showPriceDrop}
      />
    </div>
  );
}
